<template>
  <bdg-input-template
    :name="name"
    @focusout="onFocusout"
    :invalid="isInvalid"
    :required="required"
  >
    <textarea
      class="w-full"
      :class="{ invalid: isInvalid }"
      rows="5"
      v-model="computedValue"
    >
    </textarea>
  </bdg-input-template>
</template>

<script>
import BdgInputTemplate from "./BdgInputTemplate";

export default {
  name: "BdgTextArea",
  extends: BdgInputTemplate,
  components: { BdgInputTemplate },
  props: {
    value: { type: String }
  },
  data() {
    return {
      isInvalid: false
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    isValid() {
      return !!this.computedValue;
    }
  },
  methods: {
    onFocusout() {
      this.isInvalid = this.required && !this.isValid;
    }
  }
};
</script>

<style scoped></style>
